import React from 'react';
import {
    Avatar,
    Box,
    Card,
    Chip,
    Stack,
    Typography,
    useTheme,
} from "@mui/material";
import {
    AccessTimeRounded,
    BusinessRounded,
    DoneAllRounded,
    HeadsetMicRounded,
    PersonRounded,
} from "@mui/icons-material";

const _SupportMessageItem = ({ item }) => {
    const theme = useTheme();
    const isSupportAgent = Boolean(item.IsAnswer);

    const formatPersianDateTime = (dateString) => {
        if (!dateString) return '';
        try {
            return new Date(dateString).toLocaleDateString('fa-IR', {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
            });
        } catch {
            return dateString;
        }
    };

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: isSupportAgent ? 'flex-start' : 'flex-end',
                mb: 2.5,
                width: '100%',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: isSupportAgent ? 'row' : 'row-reverse',
                    alignItems: 'flex-start',
                    gap: 1.5,
                    maxWidth: { xs: '92%', sm: '80%', md: '70%' },
                }}
            >
                {/* Avatar */}
                <Avatar
                    sx={{
                        width: 38,
                        height: 38,
                        bgcolor: isSupportAgent ? 'primary.main' : 'secondary.main',
                        color: '#fff',
                        boxShadow: isSupportAgent
                            ? '0 4px 10px rgba(45, 107, 226, 0.25)'
                            : '0 4px 10px rgba(0,0,0,0.1)',
                        mt: 0.5,
                    }}
                >
                    {isSupportAgent ? (
                        <HeadsetMicRounded sx={{ fontSize: 20 }} />
                    ) : (
                        <BusinessRounded sx={{ fontSize: 20 }} />
                    )}
                </Avatar>

                {/* Message Bubble Card */}
                <Card
                    elevation={0}
                    sx={{
                        p: 2,
                        borderRadius: isSupportAgent ? '18px 18px 18px 4px' : '18px 18px 4px 18px',
                        border: '1px solid',
                        borderColor: isSupportAgent ? 'primary.light' : 'divider',
                        bgcolor: isSupportAgent ? 'action.hover' : 'background.paper',
                        boxShadow: '0 4px 16px rgba(0, 0, 0, 0.04)',
                        wordBreak: 'break-word',
                    }}
                >
                    {/* Header: Sender tag */}
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2, mb: 1 }}>
                        <Typography
                            variant="caption"
                            sx={{
                                fontWeight: 800,
                                color: isSupportAgent ? 'primary.main' : 'text.primary',
                                display: 'flex',
                                alignItems: 'center',
                                gap: 0.5,
                            }}
                        >
                            {isSupportAgent ? "کارشناس پشتیبانی جیم‌پین" : "سازمان (شما)"}
                        </Typography>

                        {item.UnreadCount > 0 && (
                            <Chip size="small" color="error" label="جدید" sx={{ height: 20, fontSize: '0.65rem' }} />
                        )}
                    </Box>

                    {/* Message Body */}
                    <Typography
                        variant="body1"
                        sx={{
                            whiteSpace: 'pre-wrap',
                            lineHeight: 1.8,
                            color: 'text.primary',
                            fontSize: '0.95rem',
                        }}
                    >
                        {item.Message}
                    </Typography>

                    {/* Footer: Timestamp & delivery check */}
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-end',
                            gap: 0.8,
                            mt: 1.2,
                            pt: 0.8,
                            borderTop: '1px solid',
                            borderColor: 'divider',
                        }}
                    >
                        <AccessTimeRounded sx={{ fontSize: 13, color: 'text.disabled' }} />
                        <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '0.72rem' }}>
                            {formatPersianDateTime(item.CreatedDate)}
                        </Typography>
                        {!isSupportAgent && (
                            <DoneAllRounded sx={{ fontSize: 15, color: 'primary.main', mr: 0.2 }} />
                        )}
                    </Box>
                </Card>
            </Box>
        </Box>
    );
};

export default _SupportMessageItem;
